import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { SpinnerIcon } from "@/lib/icons";

/**
 * Asks whether a change to one task in a sarja applies to the whole sarja.
 *
 * "Koko sarja" means this task and every later one. Earlier tasks keep their
 * values, so work already done is never rewritten.
 */
export function SeriesScopeDialog({
  open,
  onOpenChange,
  mode,
  onChoose,
  busy = false,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  mode: "edit" | "delete";
  onChoose: (scope: "single" | "series") => void;
  busy?: boolean;
}) {
  const question =
    mode === "edit"
      ? "Muokataanko koko sarjaa, vai ainoastaan tätä tehtävää?"
      : "Poistetaanko koko sarja, vai ainoastaan tämä tehtävä?";

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="md:max-w-[440px]">
        <DialogHeader className="text-left pr-8 min-w-0">
          <DialogTitle>Toistuva tehtävä</DialogTitle>
          <DialogDescription>{question}</DialogDescription>
        </DialogHeader>
        <p className="text-xs text-muted-foreground">
          Koko sarja tarkoittaa tätä ja kaikkia myöhempiä tehtäviä. Aiemmat
          tehtävät säilyvät ennallaan.
        </p>
        <DialogFooter className="gap-2">
          <Button
            variant="outline"
            onClick={() => onChoose("single")}
            disabled={busy}
          >
            Vain tämä
          </Button>
          <Button onClick={() => onChoose("series")} disabled={busy}>
            {busy && <SpinnerIcon className="mr-2 h-4 w-4 animate-spin" />}
            Koko sarja
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
